<template>
	<div id="app">
		<div itemprop="containsPlace" itemscope itemtype="http://schema.org/HotelRoom">
			<div class="container  " style="margin-top:85px;    padding-bottom: 60px;">
				<h2 itemprop="name">{{main.name}} <b>{{main.price}} руб. / сут</b></h2>
				<hr>
				<div class="col-md-6 no-padding">
					<div class="" id="adaptive-cafe">
						<div class="fixed-ar ar-4-3 img " v-for="image in main.image">
							<div class="content" :style="'background-image: url('+image+')'"></div>
						</div>
					</div>
					<link v-for="image in main.image" itemprop="photo" :href="image" />
					<div itemprop="description" class="col-md-12 no-padding hidden-xs" v-html="main.description">
					</div>
					<div class="text-container visible-xs">

						<div class="text-content short-text" v-html="main.description">
						</div>
						<div class="show-more" style="display:block;">
							<a class="booking-btn" href="#">Подробнее</a>
						</div>
					</div>

				</div>
				<div class="col-md-6" style="padding-left:2em; padding-right:0px;">
					<booking @catChange="catChange"></booking>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import Booking from './Booking.vue'
export default {
	name: 'main',
	props: ['tplData'],
	data() {
		return {
			main: this.tplData.main
		}
	},
	methods: {
		catChange(msg) {
			this.main = msg;
			try {
				history.pushState({ key: Date.now().toFixed(3), url: msg.urlId }, '', msg.urlId);
			} catch(e) {}
		}
	},
	components: {
		Booking
	}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// Main.vue?e057a6aa